export enum PremiumHistoryType {
  RENEWAL = "RENEWAL",
  CANCELLATION = "CANCELLATION",
}
